import { useState } from "react"
import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { ProductAvailability } from "../../types/productAvailabilityTypes"
import { ProductUnavailableDialog } from "./ProductUnavailableDialog"

const useStyles = makeStyles()((theme) => ({
    backdrop: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        borderRadius: "inherit",
        backgroundColor: `${theme.palette.tailwind.slate[700]}80`,
        zIndex: 1,
    },
    content: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        borderRadius: "inherit",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        zIndex: 2,
    },
    text: {
        color: "white",
        fontWeight: 600,
        textAlign: "center",
        padding: "0 1rem",
    },
}))

type ProductDisabledCoverProps = Readonly<{
    availability?: ProductAvailability
}>

export function ProductDisabledCover({ availability }: ProductDisabledCoverProps) {
    const { classes } = useStyles()
    const [open, setOpen] = useState(false)

    if (!availability || availability.isAvailable) return null

    return (
        <>
            <Box className={classes.backdrop} />
            <Box
                className={classes.content}
                onClick={(e) => {
                    e.stopPropagation()
                    setOpen(true)
                }}
            >
                <Typography className={classes.text}>{availability.shortMessage}</Typography>
            </Box>
            <ProductUnavailableDialog
                open={open}
                onClose={() => setOpen(false)}
                message={availability.message}
                title={availability.shortMessage}
            />
        </>
    )
}
